var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3739 10.6259C23.7645 11.0164 23.7645 11.6496 23.3739 12.0401L14.0406 21.3734C13.6501 21.764 13.0169 21.764 12.6264 21.3734L8.62639 17.3734C8.23586 16.9829 8.23586 16.3498 8.62639 15.9592C9.01691 15.5687 9.65008 15.5687 10.0406 15.9592L13.3335 19.2521L21.9597 10.6259C22.3502 10.2354 22.9834 10.2354 23.3739 10.6259Z",
    fill: "#F9FAFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.6665 16.0003C1.6665 8.08404 8.08355 1.66699 15.9998 1.66699C23.9161 1.66699 30.3332 8.08404 30.3332 16.0003C30.3332 23.9166 23.9161 30.3337 15.9998 30.3337C8.08355 30.3337 1.6665 23.9166 1.6665 16.0003ZM15.9998 3.66699C9.18812 3.66699 3.6665 9.18861 3.6665 16.0003C3.6665 22.812 9.18812 28.3337 15.9998 28.3337C22.8116 28.3337 28.3332 22.812 28.3332 16.0003C28.3332 9.18861 22.8116 3.66699 15.9998 3.66699Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircled);
export default __webpack_public_path__ + "static/media/check-circled.bcd151b76107ba73cc7da2eb755dab24.svg";
export { ForwardRef as ReactComponent };